import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { IInformacionGeneral } from "../../interfaces/InformacionGeneral";
import TopSection from "../../layouts/RepresentationLayout/TopSection";
import { Sections } from "../../util/types";
import { getInformacionGeneralProg } from "../../api/informacionGeneral";
import SubSectionsContainer from "./SubSections/SubSectionsContainer";
import DataSection from "./Components/DataSection";

const ProgramasMain: React.FC = () => {
  let { code } = useParams();

  const [infoGeneral, setInfoGeneral] = useState<IInformacionGeneral>();
  const [activeSection, setActiveSection] = useState<Sections>("intro");

  const displayContainer = useRef<HTMLDivElement>(null);

  const refreshActiveSection = (section:Sections) => {
    setActiveSection(section);
    displayContainer.current?.scrollIntoView({behavior:"smooth"});
  }

  return (
    <>
      <DataSection activeSection={activeSection} programa={code} refreshActiveSection={refreshActiveSection}/>
      <div ref={displayContainer}> 
        <SubSectionsContainer
          code={code!}
          section={activeSection}
          infoGeneral={infoGeneral}
        />
      </div>
    </>
  );
};

export default ProgramasMain;
